import { THREAD_MENU_ACTION } from '@/components/SecondaryLeftNavigation/components/threadRowMenuConfig'
import { handleThreadMenuDelete } from './helpers/handleThreadMenuDelete'
import { handleThreadMenuPin, handleThreadMenuUnpin } from './helpers/handleThreadMenuPin'

/** @param {object} m */
export function createThreadMenuHandler(m) {
  return (thread, actionId) => {
    if (actionId === THREAD_MENU_ACTION.SHARE) {
      m.setThreadShareThread(thread)
      return
    }
    if (actionId === THREAD_MENU_ACTION.PIN_TO_BOARD) {
      handleThreadMenuPin(thread, m)
      return
    }
    if (actionId === THREAD_MENU_ACTION.REMOVE_FROM_BOARD) {
      handleThreadMenuUnpin(thread, m)
      return
    }
    if (actionId === THREAD_MENU_ACTION.DELETE) handleThreadMenuDelete(thread, m)
  }
}
